<template>
  <div>
  <div class="client-area clearfix">
    <!--<div class="container">-->
      <!--<div class="row">-->
        <!--<div class="col-xs-12">-->
          <!--<div class="section-title">-->
            <!--<h4>Our Brand</h4>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!--&lt;!&ndash;<div class="row">&ndash;&gt;-->
        <!--&lt;!&ndash;<div class="client-owl">&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;<div class="col-md-12">&ndash;&gt;-->
            <!--&lt;!&ndash;<div class="single-client">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#"><img src="../assets/img/client/1.png" alt=""></a>&ndash;&gt;-->
            <!--&lt;!&ndash;</div>&ndash;&gt;-->
          <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--<div class="row">-->

        <!--<div class="section-button text-center">-->
          <!--<a href='#' class='slider-button margin-allowed'>View More <i class="fa fa-angle-right"></i></a>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
  </div>
  <!-- client end -->
  <!-- footer start -->
    <footer class="footer-area">
      <div class="footer-top-area">
        <div class="container">
          <div class="row">
            <div class="col-md-3 col-sm-4 col-xs-12">
              <div class="footer-logo text-center">
                <a href="index.html"><img src="../assets/img/logo/footer-logo.png" alt="Jhilmil"></a>
              </div>
            </div>
            <div class="col-md-3 col-sm-2 hidden-xs">
              <div class="footer-social text-center">
                <ul>
                  <li><a href="www.facebook.com" target="_blank"><i class="fa fa-facebook"></i></a></li>
                  <li><a href="www.twitter.com" target="_blank"><i class="fa fa-twitter"></i></a></li>
                  <li><a href="www.linkedin.com" target="_blank"><i class="fa fa-linkedin"></i></a></li>
                  <li class="hidden-sm"><a href="www.googleplus.com" target="_blank"><i class="fa fa-google-plus"></i></a></li>
                  <li class="hidden-sm"><a href="www.instagram.com" target="_blank"><i class="fa fa-instagram"></i></a></li>
                </ul>
              </div>
            </div>
            <div class="col-md-6 col-sm-6 hidden-xs">
              <!--<div class="footer-widget-newsletter">-->
                <!--<h4 class="newsletter">newletter</h4>-->
                <!--<form action="#">-->
                  <!--<input type="text" placeholder="Enter your email here...">-->
                  <!--<a class="submit" href="#">Subscribe</a>-->
                <!--</form>-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="footer-middle-area">
        <div class="container">
          <div class="row">
            <div class="col-md-4 col-sm-6">
              <div class="footer-widget">
                <h5>Contact</h5>
                <div class="single-footer-contact">
                  <div class="footer-icon">
                    <img src="../assets/img/cart/1.png" alt="">
                  </div>
                  <div class="footer-contact-info">
                    <p>8901 Marmora Raod, </p>
                    <p>Glasgow, D04  89GR</p>
                  </div>
                </div>
                <div class="single-footer-contact">
                  <div class="footer-icon">
                    <img src="../assets/img/cart/2.png" alt="">
                  </div>
                  <div class="footer-contact-info">
                    <p>Telephone : (801) 4256  9856</p>
                    <p>Telephone : (801) 4256  9658</p>
                  </div>
                </div>
                <div class="single-footer-contact">
                  <div class="footer-icon">
                    <img src="../assets/img/cart/3.png" alt="">
                  </div>
                  <div class="footer-contact-info">
                    <p>Email : <a href="#">admin@devitems.com</a></p>
                    <p>Web : <a href="http://devitems.com/">www.devitems.com</a></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-3">
              <div class="footer-widget">
                <h5>Company</h5>
                <ul>
                  <li><i class="fa fa-circle"></i><a href="index.html">Home</a></li>
                  <li><i class="fa fa-circle"></i><a href="about.html">About us</a></li>
                  <li><i class="fa fa-circle"></i><a href="contact.html">Contact us</a></li>
                  <li><i class="fa fa-circle"></i><a href="blog.html">Our blog</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Supports center</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Privacy policy</a></li>
                </ul>
              </div>
            </div>
            <div class="col-md-3 hidden-sm">
              <div class="footer-widget">
                <h5>Support</h5>
                <ul>
                  <li><i class="fa fa-circle"></i><a href="#">Delivery information</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Order tracking</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Return product</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Gift card</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Home delivery</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Online support</a></li>
                </ul>
              </div>
            </div>
            <div class="col-md-2 col-sm-3">
              <div class="footer-widget">
                <h5>Information</h5>
                <ul>
                  <li><i class="fa fa-circle"></i><a href="#">Payment option</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Shipping</a></li>
                  <li><i class="fa fa-circle"></i><a href="checkout.html">Checkout</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Discount</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Sitemap</a></li>
                  <li><i class="fa fa-circle"></i><a href="#">Service</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="footer-bottom-area">-->
        <!--<div class="container">-->
          <!--<div class="row">-->
            <!--<div class="col-md-4 col-sm-6">-->
              <!--<div class="copyright">-->
                <!--<p>Copyright @ 2016 <span><a href="http://devitems.com/">Devitems</a></span>. All right reserved. </p>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="col-md-4 col-sm-6">-->
              <!--<div class="footer-menu text-center">-->
                <!--<nav>-->
                  <!--<ul>-->
                    <!--<li><a href="">Site Map</a></li>-->
                    <!--<li><a href="contact.html">Contact Us</a></li>-->
                    <!--<li><a href="wishlist.html">Wish List</a></li>-->
                    <!--<li><a href="#">Newsletter</a></li>-->
                  <!--</ul>-->
                <!--</nav>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="col-md-4 hidden-sm">-->
              <!--<div class="payment text-right">-->
                <!--<img src="../assets/img/payment/1.png" alt="">-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
    </footer>
  </div>
</template>

<script>
export default {
  name: 'mcfoot'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mcfoot.vue